<template>
  <vs-popup :title="title" :active.sync="active">
    <div>
      <!-- Alerta de produto duplicado -->
      <div class="mb-6" v-if="checkItemList()">
        <vs-alert title="Atenção" active="true" color="danger">
          Já existe um desconto configurado para este produto.
        </vs-alert>
      </div>

      <form ref="form" role="form" @submit.stop.prevent="onSubmit">
        <!-- Tipo desconto -->
        <div class="vx-row mb-6">
          <div class="vx-col w-full mb-3">
            <span>Tipo Desconto</span>
          </div>
          <div class="vx-col">
            <vs-radio
              v-for="item in otpionsTipoDesconto"
              :key="item.idTipoDesconto"
              v-model="formCadastroProdutosValores.idTipoDesconto"
              :vs-name="item.tipoDesconto"
              :vs-value="item.idTipoDesconto"
              class="w-full mb-3"
            >
              {{ item.tipoDesconto }}
            </vs-radio>
          </div>
        </div>

        <div v-if="formCadastroProdutosValores.idTipoDesconto != null">
          <!-- Valor -->
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <label for="valor">
                Informe o valor em
                {{
                  getLabelTipoDesconto(
                    formCadastroProdutosValores.idTipoDesconto,
                  )
                }}
                do desconto do produto
                <b>{{ getNameProduto() }}</b>
              </label>
              <vs-input
                size="large"
                class="w-full"
                name="valor"
                id="valor"
                v-money="returnConfigMoney()"
                v-model.lazy="formCadastroProdutosValores.valor"
                :danger="!validate()"
                val-icon-danger="clear"
                danger-text="Preencha este Campo"
                :maxlength="maxLengthValor()"
                autocomplete="off"
              />
            </div>
          </div>

          <!-- Mensagem de Validação -->
          <vs-alert
            v-if="showMessageErro && !validate()"
            color="danger"
            title="Atenção!!"
            active="true"
            class="my-3"
            style="height: auto !important"
          >
            <ul>
              <li
                class="mb-2"
                v-for="error in messageErrosValidate()"
                :key="error.id"
              >
                {{ error.message }}
              </li>
            </ul>
          </vs-alert>

          <!-- Botão Salvar -->
          <div class="vx-row">
            <div class="vx-col w-full text-right">
              <BotaoSubmit
                name="SalvarDespontoProduto"
                variant="success"
                edit="false"
                :aguarde="aguardeCadastro"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  </vs-popup>
</template>

<script>
//#region Import's

import BotaoSubmit from '../../components/BotaoSubmit.vue';
import utilsList from './../../utils/list';
import { VMoney } from 'v-money';

//#endregion

export default {
  components: { BotaoSubmit },
  props: ['title', 'active', 'produtoSelecionado', 'listDescontoProduto'],
  directives: { money: VMoney },
  data() {
    const defaultFormProdutosValores = Object.freeze({
      idTipoDesconto: null,
      idProduto: null,
      valor: 0,
    });
    const TIPO_PORCENTAGEM = 1;
    const TIPO_VALOR = 2;
    const otpionsTipoDesconto = [
      {
        idTipoDesconto: TIPO_PORCENTAGEM,
        tipoDesconto: 'Porcentagem',
        sufixo: '%',
      },
      {
        idTipoDesconto: TIPO_VALOR,
        tipoDesconto: 'Valor',
        sufixo: 'R$',
      },
    ];
    return {
      defaultFormProdutosValores,
      otpionsTipoDesconto,
      formCadastroProdutosValores: Object.assign(
        {},
        defaultFormProdutosValores,
      ),
      aguardeCadastro: false,
      utilsList,
      TIPO_PORCENTAGEM,
      TIPO_VALOR,
      showMessageErro: false,
    };
  },
  methods: {
    resetForm() {
      this.formCadastroProdutosValores = Object.assign(
        {},
        this.defaultFormProdutosValores,
      );
    },
    close() {
      this.resetForm();
      this.$refs.form.reset();
      this.$emit('close');
    },
    getTipoDescontoSelecionado(value) {
      return this.otpionsTipoDesconto.find((x) => x.idTipoDesconto == value);
    },
    getLabelTipoDesconto(value) {
      const result = this.getTipoDescontoSelecionado(value);
      if (result) {
        return ` ${result.sufixo} `;
      }
      return '';
    },
    onSubmit() {
      const result = this.validate();
      this.showMessageErro = !result;

      if (!result) {
        return;
      }

      this.aguardeCadastro = true;

      // Recupera as informações do objeto resultante
      const { idProduto, nomeProduto } = this.produtoSelecionado;

      const prefixo = this.getTipoDescontoSelecionado(
        this.formCadastroProdutosValores.idTipoDesconto,
      ).sufixo;

      const valor = this.convertValorNumber();
      const valorMasked = this.formCadastroProdutosValores.valor;
      const { idTipoDesconto } = this.formCadastroProdutosValores;

      // Montagem do item da lista Desconto Produto
      const item = {
        idTipoDesconto,
        idProduto,
        nomeProduto,
        prefixo,
        valor,
        valorMasked,
      };

      // Atuliza a lista de produtos selecionados
      this.removeItemDuplicado();
      this.addItemListDesctonProduto(item);
      this.close();

      this.aguardeCadastro = false;
    },
    convertValorNumber() {
      const convert = String(this.formCadastroProdutosValores.valor)
        .replace(new RegExp('[.]', 'g'), '')
        .replace(',', '.');
      return Number(convert);
    },
    validate() {
      /**
       * Utilizando o VMoney como diretiva não é possível ter o retorno como number,
       * sendo assim não é possivel usar o vee-validate para criar as regras de validação
       * no próprio input
       */
      const valor = this.convertValorNumber();

      if (valor) {
        if (
          this.formCadastroProdutosValores.idTipoDesconto ==
          this.TIPO_PORCENTAGEM
        ) {
          return valor <= 100;
        }
        return valor > 0;
      }

      return false;
    },
    maxLengthValor() {
      if (
        this.formCadastroProdutosValores.idTipoDesconto == this.TIPO_PORCENTAGEM
      ) {
        return 3;
      }
      return 15;
    },
    getNameProduto() {
      if (this.produtoSelecionado) {
        return this.produtoSelecionado.nomeProduto;
      }
      return null;
    },
    onClickCloseButton() {
      this.close();
    },
    getIndexItemList() {
      if (this.produtoSelecionado) {
        return this.listDescontoProduto.findIndex(
          (x) => x.idProduto == this.produtoSelecionado.idProduto,
        );
      }
      return -1;
    },
    checkItemList() {
      return this.getIndexItemList() >= 0;
    },
    removeItemDuplicado() {
      const index = this.getIndexItemList();
      if (index >= 0) {
        this.listDescontoProduto.splice(index, 1);
      }
    },
    addItemListDesctonProduto(value) {
      this.listDescontoProduto.push(value);
    },
    returnConfigMoney() {
      const precision =
        this.formCadastroProdutosValores.idTipoDesconto == this.TIPO_PORCENTAGEM
          ? 0
          : 2;
      return {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision,
      };
    },
    messageErrosValidate() {
      const valor = this.convertValorNumber();

      if (!valor) {
        return [{ id: 1, message: "O campo 'valor' é obrigatório" }];
      }

      if (
        this.formCadastroProdutosValores.idTipoDesconto ==
          this.TIPO_PORCENTAGEM &&
        valor > 100
      ) {
        return [
          { id: 1, message: 'O valor do desconto não pode ser maior que 100%' },
        ];
      }
    },
  },
  mounted() {
    const next = this.$children[0].$refs.btnclose;
    next.$el.addEventListener('click', this.onClickCloseButton, false);
  },
};
</script>

<style></style>
